import { StandardEvents } from '@shopify/events';

class VariantDescription extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section');

    if (!section) return;

    section.addEventListener(
      StandardEvents.productSelect,
      this.handleVariantChange
    );
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section');

    if (!section) return;

    section.removeEventListener(
      StandardEvents.productSelect,
      this.handleVariantChange
    );
  }

  handleVariantChange = (event) => {
    event.promise
      .then(({ detail }) => {

        const newBlock = detail.html.querySelector(
          'variant-description'
        );

        if (!newBlock) return;

        this.replaceChildren(
          ...newBlock.childNodes
        );

      })
      .catch((error) => {
        if (error?.name !== 'AbortError') {
          console.warn(error);
        }
      });
  };
}

if (!customElements.get('variant-description')) {
  customElements.define(
    'variant-description',
    VariantDescription
  );
}